























































































































































































































































































































































import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import Word from "@/components/cards/word/singleWord.vue";

import { Dialog, Popup, Notify } from "vant";
import axios from "axios";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */

@Component({
  components: { Word },
})
export default class NewSentence extends Vue {
  @Prop() show1!: any;
  @Prop() words!: any;
  @Prop() wordLevel!: any;
  @Prop() CategoryId!: any;
  @Prop() Day!: any;
  @Prop() index!: any;
  @Prop() Editable!: any;

  copyWord: any = "";
  newSynonyms = "";
  newAntonyms = "";
  newExample = "";
  newFalseOption = "";
  errors: any = [];
  @Emit("ModalClose")
  ModalClose() {
    return false;
  }

  new_word: any = {
    en: null,
    bn: null,
    phBn: null,
    toEn: null,
    partsOfSpeech: null,
    presentForm: null,
    pastForm: null,
    pastParticipleForm: null,
    description: null,
    synonyms: [],
    antonyms: [],
    mockFalseOptions: [],
    imageUrl: null,

    examples: [],
  };
  AddSynonym() {
    if (this.newSynonyms != "") {
      this.copyWord.synonyms.push(this.newSynonyms);
    }
    this.newSynonyms = "";
  }
  RemoveSynonym(synIndex: any) {
    this.$delete(this.copyWord.synonyms, synIndex);
  }
  AddAntonyms() {
    if (this.newAntonyms != "") {
      this.copyWord.antonyms.push(this.newAntonyms);
    }
    this.newAntonyms = "";
  }
  RemoveAntonyms(anIndex: any) {
    this.$delete(this.copyWord.antonyms, anIndex);
  }

  AddExamples() {
    if (this.newExample != "") {
      this.copyWord.examples.push(this.newExample);
    }
    this.newExample = "";
  }
  RemoveExamples(exIndex: any) {
    this.$delete(this.copyWord.examples, exIndex);
  }
  AddFalseOption() {
    if (this.newFalseOption != "") {
      this.words[this.index].mockFalseOptions.push(this.newFalseOption);
    }
    this.newFalseOption = "";
  }
  RemoveFalseOption(optIndex: any) {
    this.$delete(this.words[this.index].mockFalseOptions, optIndex);
  }

  checkRequired() {
    if (
      this.words[this.Day].words[this.index].en &&
      this.words[this.Day].words[this.index].bn &&
      this.words[this.Day].words[this.index].partsOfSpeech
    ) {
      return true;
    }
    this.errors = [];
    if (!this.words[this.Day].words[this.index].en) {
      this.errors.push("word required.");
    }
    if (!this.words[this.Day].words[this.index].bn) {
      this.errors.push("bangla word required.");
    }

    if (!this.words[this.Day].words[this.index].partsOfSpeech) {
      this.errors.push("Parts Of Speech required.");
    }
  }
  AddNewWord() {
    if (this.checkRequired()) {
      if (this.$route.name == "main.word_of_the_month") {
        this.updateField();
        this.show1 = false;
        this.UpdateDayWord();
      } else if (this.$route.name == "main.dictionary") {
        console.warn(this.words);
        this.words.push({
          en: this.new_word.en,
          bn: this.new_word.bn,
          translationType: "EN_2_BN",
          toEn: this.new_word.toEn,
          description: this.new_word.description,
          partsOfSpeech: this.new_word.partsOfSpeech,
          presentForm: this.new_word.presentForm,
          pastForm: this.new_word.pastForm,
          pastParticipleForm: this.new_word.pastParticipleForm,
          synonyms: this.new_word.synonyms,
          antonyms: this.new_word.antonyms,
          mockFalseOptions: this.new_word.mockFalseOptions,
          examples: this.new_word.examples,
          imageUrl: this.new_word.imageUrl,
        });
        window.scrollTo(0, document.body.scrollHeight);
        this.AddInDictionary();
        this.MakeNull();
      } else {
        this.wordLevel.words.push({
          id: "",
          en: this.new_word.en,
          bn: this.new_word.bn,
          translationType: "EN_2_BN",
          toEn: this.new_word.toEn,
          description: this.new_word.description,
          partsOfSpeech: this.new_word.partsOfSpeech,
          presentForm: this.new_word.presentForm,
          pastForm: this.new_word.pastForm,
          pastParticipleForm: this.new_word.pastParticipleForm,
          synonyms: this.new_word.synonyms,
          antonyms: this.new_word.antonyms,
          examples: this.new_word.examples,
          mockFalseOptions: this.new_word.mockFalseOptions,
          imageUrl: this.new_word.imageUrl,
          isBookmarked: false,
          wordCategoryId: "",
          isUserGenerated: false,
          agreedToContribute: false,
          bookmarkCategoryName: "",
          isExpandable: true,
          frequency: 0,
          weight: 0,
        });
        window.scrollTo(0, document.body.scrollHeight);

        this.MakeNull();
      }
    } else alert(false);
    // word.whoBn = word.whoEn = word.sentenceBn = word.sentenceEn = "";
  }
  updateField() {
    this.words[this.Day].words[this.index] = this.copyWord1;
  }
  MakeNull() {
    this.new_word.en = null;
    this.new_word.bn = null;
    this.new_word.phBn = null;
    this.new_word.partsOfSpeech = null;
    this.new_word.presentForm = null;
    this.new_word.pastForm = null;
    this.new_word.pastParticipleForm = null;
    this.new_word.description = null;
    this.new_word.synonyms = [];
    this.new_word.antonyms = [];
    this.new_word.imageUrl = null;
    this.new_word.examples = [];
  }

  AddInDictionary() {
    const data = {
      word: {
        en: this.new_word.en,
        bn: this.new_word.bn,
        translationType: "EN_2_BN",
        description: this.new_word.description,
        mockFalseOptions: this.new_word.mockFalseOptions,
        toEn: this.new_word.toEn,
        partsOfSpeech: this.new_word.partsOfSpeech,
        presentForm: this.new_word.presentForm,
        pastForm: this.new_word.pastForm,
        pastParticipleForm: this.new_word.pastParticipleForm,
        synonyms: this.new_word.synonyms,
        antonyms: this.new_word.antonyms,
        examples: this.new_word.examples,
        imageUrl: this.new_word.imageUrl,
      },
    };

    const response = axios
      .post("https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/AddWord", data)
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Word is not added" });
      });
    Notify({ type: "success", message: "Word is added" });
  }
  DeleteWord(index: any) {
    Dialog.confirm({
      title: "Delete",
      message: "Are you sure?",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    })
      .then(() => {
        this.show1 = false;
        this.$delete(this.words[this.Day].words, index);
        if (this.$route.name == "main.word_of_the_month") {
          this.show1 = true;
          this.UpdateDayWord();
          this.ModalClose();
        }
      })
      .catch(() => {
        // on cancel
      });
  }

  UpdateDayWord() {
    this.show1 = false;
    const data = {
      words_of_the_day: {
        day: this.Day,
        words: this.words[this.Day].words,
      },
    };

    const response = axios
      .post(
        "https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/PutWordsOfTheDay",
        data
      )
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Word is not added in days" });
      });
    Notify({ type: "success", message: "Word is added in days" });
  }

  partsOfSpeech = [
    "Noun",
    "Pronoun",
    "Verb",
    "Adjective",
    "Adverb",
    "Preposition",
    "Conjunction",
    "Interjenction",
  ];

  //   showPopup() {
  //     this.show1 = true;
  //     this.copyWord1();
  //   }
  get copyWord1() {
    const obj = this.words[this.Day].words[this.index];
    this.copyWord = Object.assign({}, obj);
    return this.copyWord;
  }
  //   mounted() {
  //     const obj = this.words[this.Day].words[this.index];
  //     this.copyWord = Object.assign({}, obj);
  //     // console.log("copy ", copy); // { a: 1 }
  //   }
}
